// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.persona.RentalManagerUserPropertyOwnershipVerificationWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  ListingAlias,
  PropertyOwnershipVerificationStartWebResponseDto,
  PropertyOwnershipVerificationStateWebResponseDto,
  StartPropertyOwnershipVerificationRequestDto,
} from '../..';

interface GetVerificationStateParams {
  listingAlias: ListingAlias;
}

export const RentalManagerUserPropertyOwnershipVerificationWebApiHandler_getVerificationState_Path =
  '/api/web/v1/users/properties/persona/getVerificationState';

/**
 * Get the property ownership verification state for a listing
 */
export const RentalManagerUserPropertyOwnershipVerificationWebApiHandler_getVerificationState = (
  getParams: GetVerificationStateParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetVerificationStateParams, never, PropertyOwnershipVerificationStateWebResponseDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyOwnershipVerificationWebApiHandler_getVerificationState_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyOwnershipVerificationWebApiHandler_startOrResume_Path =
  '/api/web/v1/users/properties/persona/startOrResume';

/**
 * Start or resume a property ownership verification inquiry for a listing
 */
export const RentalManagerUserPropertyOwnershipVerificationWebApiHandler_startOrResume = (
  postData: StartPropertyOwnershipVerificationRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    StartPropertyOwnershipVerificationRequestDto,
    PropertyOwnershipVerificationStartWebResponseDto
  >(
    {
      endpoint: RentalManagerUserPropertyOwnershipVerificationWebApiHandler_startOrResume_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
